export default "__VITE_ASSET__B2d7_iOp__"